import { render, staticRenderFns } from "./alertbox_component.vue?vue&type=template&id=ffead31c&"
import script from "./alertbox_component.vue?vue&type=script&lang=js&"
export * from "./alertbox_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports